import React, { useMemo } from "react";
import { Alert, Modal, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { buildStockReplenishmentReturnNavigation } from "../utils/stockReplenishment";

const { Paragraph, Text } = Typography;

const StockReplenishmentReturnModal = ({
  open,
  replenishment,
  method = "purchase",
  stayLabel = "Rester ici",
  onStay,
  onReturn,
}) => {
  const navigation = useMemo(
    () =>
      buildStockReplenishmentReturnNavigation(replenishment, method),
    [method, replenishment]
  );

  if (!navigation) return null;

  const operationLabel =
    method === "adjustment" ? "L’ajustement" : "L’achat";
  const sourceType = navigation.state?.stockReplenishmentReturn?.source_type;
  const isSalesReturn = sourceType === "pos" || sourceType === "sale";

  return (
    <Modal
      open={open}
      title="Stock réapprovisionné"
      okText={navigation.label}
      cancelText={stayLabel}
      onOk={() => onReturn?.(navigation)}
      onCancel={onStay}
      closable={false}
      maskClosable={false}
      destroyOnClose
    >
      <Alert
        type="success"
        showIcon
        icon={<CheckCircleOutlined />}
        message={`${operationLabel} a mis à jour le stock avec succès.`}
        style={{ marginBottom: 16 }}
      />
      <Paragraph>
        {isSalesReturn
          ? "Retournez au panier d’origine pour restaurer la vente et revalider automatiquement les produits, les prix et le stock actualisé."
          : "Retournez au processus d’origine pour recalculer automatiquement les besoins avec le stock actualisé."}
      </Paragraph>
      <Text type="secondary">
        {isSalesReturn
          ? "La vente et son encaissement ne seront pas validés automatiquement : votre confirmation restera nécessaire."
          : "La production ne sera pas lancée automatiquement : une confirmation restera nécessaire après le recalcul."}
      </Text>
    </Modal>
  );
};

export default StockReplenishmentReturnModal;
